// extracted by mini-css-extract-plugin
export var page = "PageContent-module--page--wh2x2";